
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.55 11.748H11.847v6.748h3.502c4.43 0 4.647-4.499 4.201-6.748z","fill":"#E345FF"}}),_c('path',{attrs:{"d":"M13.524 1.504H1.556v13.992a3 3 0 003 3H15.78c-2.062 0-2.255-2.968-2.255-4.54V1.504z","fill":"#5935DD"}})])
          )
        }
      }
    